"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Logo = _interopRequireDefault(require("./Logo.svg"));

var _LogoCompact = _interopRequireDefault(require("./LogoCompact.svg"));

var _LogoModule = _interopRequireDefault(require("./Logo.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

Logo.propTypes = {
  fluid: _propTypes.default.bool,
  compact: _propTypes.default.bool,
  name: _propTypes.default.string,
  url: _propTypes.default.string
};

function Logo(_ref) {
  var _classNames;

  var compact = _ref.compact,
      fluid = _ref.fluid,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'Be-novative' : _ref$name,
      url = _ref.url,
      rest = _objectWithoutProperties(_ref, ["compact", "fluid", "name", "url"]);

  var logoClassNames = (0, _classnames.default)(_LogoModule.default['Logo__Image'], rest.className, (_classNames = {}, _defineProperty(_classNames, _LogoModule.default['Logo__Image--compact'], compact), _defineProperty(_classNames, _LogoModule.default['Logo__Image--fluid'], fluid), _classNames));
  var src = compact ? _LogoCompact.default : _Logo.default;

  if (url) {
    src = url;
  }

  return /*#__PURE__*/_react.default.createElement("figure", {
    className: _LogoModule.default.Logo
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: src,
    className: logoClassNames,
    alt: "".concat(name, " logo")
  }));
}

var _default = Logo;
exports.default = _default;

//# sourceMappingURL=Logo.js.map